<template>
  <div
    class="flex-auto flex flex-column"
    style="border-right: solid 1px #e6e6e6; padding: 12px; flex-basis: 240px;"
  >
    <div
      class="flex-auto flex flex-row h-center v-center"
      style="margin-top: 12px;"
    >
      <el-popover
        ref="addPopper"
        width="200"
        class="guide-popover"
        trigger="manual"
        :value="guideVisible[0]"
        :popper-options="{
          boundariesElement: 'body',
          gpuAcceleration: false,
        }"
      >
        <el-button
          slot="reference"
          v-popover:addPopper
          type="primary"
          size="small"
          icon="el-icon-plus"
          style="font-size: 18px; padding: 10px 60px;"
          @click.stop="handleAdd"
          >新建</el-button
        >
        <div @click.stop="() => {}">
          <div>您可以点击这里可以创建新的收集表</div>
          <div style="text-align: right;">
            <el-button
              type="primary"
              size="mini"
              @click.stop="handleGuideClick(0)"
              >我知道了</el-button
            >
          </div>
        </div>
      </el-popover>
    </div>
    <el-divider direction="horizontal"></el-divider>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      style="flex: 1 1 0%; border: none; position: unset;"
    >
      <el-menu-item index="1">
        <router-link
          :to="{ name: 'home' }"
          style="text-decoration: none; color: inherit;"
        >
          <div>
            <i class="el-icon-document"></i>
            <span slot="title">我的文档</span>
          </div>
        </router-link>
      </el-menu-item>
      <el-menu-item index="2">
        <router-link
          :to="{ name: 'home', query: { published: false } }"
          style="text-decoration: none; color: inherit;"
        >
          <div>
            <i class="el-icon-document"></i>
            <span slot="title">未发布</span>
          </div>
        </router-link>
      </el-menu-item>
      <el-menu-item index="3" style="position: unset;">
        <!-- <i class="el-icon-s-opportunity" style="color: grey;"></i> -->

        <el-popover
          slot="title"
          ref="feedbackPopper"
          class="guide-popover feedback-popover"
          width="200"
          trigger="manual"
          v-model="guideVisible[1]"
          :popper-options="{
            boundariesElement: 'body',
            gpuAcceleration: false,
          }"
        >
          <a
            slot="reference"
            v-popover:feedbackPopper
            :href="feedbackUrl"
            target="_blank"
            style="
              color: black;
              display: flex;
              margin: 0 -20px;
              padding: 0 20px;
            "
          >
            <div>
              <img
                src="../../assets/feedback.png"
                style="padding-left: 5px; margin-right: 5px;"
              />
              <el-button type="text" style="color: black;">建议反馈</el-button>
            </div>
          </a>
          <div>
            <div style="white-space: pre-wrap;">
              您可以点击这里向我们提出您宝贵的意见和建议
            </div>
            <div style="text-align: right;">
              <el-button
                type="primary"
                size="mini"
                @click.stop="handleGuideClick(1)"
                >我知道了</el-button
              >
            </div>
          </div>
        </el-popover>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import { Popover, Button, Divider } from "element-ui";
import { MenuItem, Menu } from "element-ui";

export default {
  name: "aside-menu",
  components: {
    [Popover.name]: Popover,
    [Button.name]: Button,
    [Divider.name]: Divider,
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
  props: {
    guideVisible: {
      type: Array,
    },
    feedbackUrl: String,
    activeIndex: String,
  },
  methods: {
    handleAdd() {
      this.$emit("add");
    },
    handleGuideClick(index) {
      this.$emit("click-guide", index);
    },
  },
};
</script>
<style>
.guide-popover > .el-popover.el-popper {
  position: fixed;
  top: 160px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  left: 180px;
  width: 200px;
}
.guide-popover > .el-popover.el-popper::before {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  content: " ";
  border-width: 6px;
  top: -6px;
  /* margin-left: -6px; */
  border-top-width: 0;
  border-bottom-color: rgba(0, 0, 0, 0.6);
}
.guide-popover > .el-popover.el-popper > .popper__arrow::after {
  border-bottom-color: rgba(0, 0, 0, 0.6);
}
.guide-popover.feedback-popover > .el-popover.el-popper {
  left: 80px;
  top: 280px;
  position: absolute;
}
</style>
